<template>
    <ies-form-field :field="field">
        <div class="checkbox">
            <input
                type="checkbox"
                v-model="isStayRestricted"
                :disabled="field.disabled"
            >
        </div>

        <ies-date-range-rows
            v-if="isStayRestricted"
            :date-ranges="dateRanges"
            :disabled="field.disabled"
        ></ies-date-range-rows>
    </ies-form-field>
</template>

<script>
var dateRangeRowsModule = require('./DateRangeRows.vue');
var newDateRange = dateRangeRowsModule.newDateRange;

export default {
    name: 'ies-input-is-stay-restricted',
    props: ['field', 'page'],
    components: {
        'ies-form-field': require('./FormField.vue').default,
        'ies-date-range-rows': dateRangeRowsModule.default,
    },
    data () {
        return {
            isStayRestricted: false,
            dateRanges: [],
            rateTypeKey: null,
            loading: false,
        };
    },
    methods: {
        initFromFieldValue: function () {
            var existingValue = this.field.value || this.field.oldValue;

            if (existingValue && typeof existingValue === 'object') {
                this.isStayRestricted = !!existingValue.isStayRestricted;
                if (Array.isArray(existingValue.dateRanges)) {
                    this.dateRanges = existingValue.dateRanges.map(function (dateRange) {
                        return {
                            from: dateRange.from || '',
                            to: dateRange.to || '',
                            fromMenuOpen: false,
                            toMenuOpen: false,
                        };
                    });
                }
            } else {
                this.isStayRestricted = parseInt(existingValue) === 1;
            }

            if (this.isStayRestricted && this.dateRanges.length === 0) {
                this.dateRanges.push(newDateRange());
            }
        },

        setRateKeyFromUrl: function () {
            if (!this.page || !this.page.edit_url) {
                return;
            }

            let bits = this.page.edit_url.split('/');
            let urlBits = location.pathname.split('/').splice(1);

            bits.forEach(function (bit, index) {
                if (bit === '{RateType.rate_type_key}') {
                    this.rateTypeKey = parseInt(urlBits[index]);
                }
            }.bind(this));
        },

        loadExistingPeriods: function () {
            this.loading = true;

            axios.get('/api/rate-type-stay-restricted/' + this.rateTypeKey).then(function (response) {
                var loaded = response.data.dateRanges.map(function (dateRange) {
                    return {
                        from: dateRange.from || '',
                        to: dateRange.to || '',
                        fromMenuOpen: false,
                        toMenuOpen: false,
                    };
                });

                this.dateRanges = loaded.length > 0 ? loaded : [newDateRange()];
            }.bind(this)).finally(function () {
                this.loading = false;
            }.bind(this));
        },
    },
    computed: {
        submissionData: function () {
            return {
                rateTypeKey: this.rateTypeKey,
                isStayRestricted: this.isStayRestricted,
                dateRanges: this.dateRanges.map(function (dateRange) {
                    return {
                        from: dateRange.from,
                        to: dateRange.to,
                    };
                }),
            };
        },
    },
    watch: {
        submissionData: {
            deep: true,
            handler: function (value) {
                this.field.value = value;
            },
        },

        isStayRestricted: function (value) {
            if (value && this.dateRanges.length === 0) {
                this.dateRanges.push(newDateRange());
            }
        },
    },
    created: function () {
        this.initFromFieldValue();
        this.setRateKeyFromUrl();
        this.field.value = this.submissionData;

        if (this.isStayRestricted && this.rateTypeKey) {
            this.loadExistingPeriods();
        }
    },
};
</script>
